// inputs.js
import { validateRequired,validateLength, validateNotNull,validateNonZeroInteger, validateSelectInteger }from "../../../../helpers/validationsForm";

const Inputs = [
  {
    id: 1,
    label: "Descripcion",
    name: "barrio_descripcion",
    type: "text",
    placeholder: "Ingrese la descripcion",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 3, maxLength: 40 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 2,
    label: "Localidad",
    name: "loc_id",
    type: "select",
    placeholder: [],
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateSelectInteger(value);
      if (requiredError) {
        return requiredError;
      }


      // Si no hay errores
      return null;
    }
  }, 
];

export default Inputs;
